module.exports = __webpack_public_path__ + "img/home_more_info_banner.26db0b93.jpg";